function init() {
  const $BookEdition = jQuery('.BookEdition');
  if (!$BookEdition.length) return;

  initBookEdition($BookEdition);
  checkUrlHash();
}

function initBookEdition($BookEdition) {
  // Récupéré dès l'init : modals.js retire le template du DOM à la première
  // ouverture mais relit son innerHTML ensuite, on garde donc la référence.
  const w2bIframe = document.querySelector('[data-modal-data="book-header-buy-book"] .iframe-where2buy');

  $BookEdition.on('click', function () {
    $BookEdition.removeClass('active');
    jQuery(this).addClass('active');

    var paragraphId = jQuery(this).data('paragraph');
    var nodeId = jQuery(this).data('node');

    updateWhere2Buy(w2bIframe, String(jQuery(this).data('ean') || ''));
    loadParagraph(nodeId, paragraphId);
  });
}

// EAN de l'édition sélectionnée en premier (onglet actif de l'iframe),
// puis un EAN de secours. Même logique que node--book--full.html.twig.
function updateWhere2Buy(iframe, ean) {
  if (!iframe || !ean) return;

  const { w2bBase, w2bPaper, w2bDigital } = iframe.dataset;
  const backup = [w2bDigital, w2bPaper].find(v => v && v !== ean);
  iframe.src = w2bBase + ean + (backup ? '/' + backup : '');
}

function loadParagraph(nodeId, paragraphId) {
  jQuery.ajax({
    url: '/paragraph-api/' + nodeId + '/' + paragraphId,
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      if (data.titre) {
        jQuery('.BookHeader-infos--title').html(data.titre);
      }
      if (data.couv_uri) {
        jQuery('.BookHeader-cover img').attr('src', data.couv_uri);
      }
      const $collection = jQuery('.BookHeader-collection');
      if (data.collection) {
        $collection.find('a').attr('href', data.collection.url).text(data.collection.name);
        $collection.prop('hidden', false);
      } else {
        $collection.prop('hidden', true);
      }
      jQuery('.BookHeader-tobereleased').prop('hidden', !data.a_paraitre);
      if (data.date_publication) {
        jQuery('.BookMetas-intro strong').html(data.date_publication);
      }
      if (data.description.ean) {
        jQuery('.BookEditions-ean').html('EAN : ' + data.description.ean);
      }
      // Même format que le template : "140 mm × 205 mm – 320 pages".
      const { edition_width: width, edition_length: length, pages } = data.description;
      const dimensions = [width && width + ' mm', length && length + ' mm'].filter(Boolean).join(' × ');
      const details = [dimensions, pages > 0 && pages + ' pages'].filter(Boolean).join(' – ');
      jQuery('.BookEditions-details').text(details).prop('hidden', !details);

      const price = data.description.price && parseFloat(data.description.price.replace(',', '.')) > 0 ? data.description.price + ' €' : '';
      jQuery('.BookEditions-price').text(price).prop('hidden', !price);
    },
    error: function (error) {
      console.error('Erreur lors de la récupération du paragraphe :', error);
    }
  });
}

function checkUrlHash() {
  const hash = window.location.hash.substring(1);
  if (hash) {
    const $targetEdition = jQuery(`.BookEdition[data-paragraph="${hash}"]`);
    if ($targetEdition.length) {
      $targetEdition.trigger('click');
    }
  }
}

export default { init };
